import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService {

  isPhone: boolean = false;
  isMediumPhone: boolean = false;
  isTablet: boolean = false;
  isMobile: boolean = false;
  isDesktop: boolean = false;
  isMediumDesktop: boolean = false;
  isPortrait: boolean = false;
  isLandscape: boolean = false;
  showCompactButtons: boolean = false;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe([
      '(max-width: 450px)',
      '(max-width: 575px)',
      '(max-width: 768px)',
      '(max-width: 991px)',
      '(min-width: 992px)',
      '(max-width: 1200px)',
      '(orientation: portrait)',
      '(orientation: landscape)'
    ]).subscribe(result => {
      const breakpoints = result.breakpoints;

      this.isPhone = breakpoints['(max-width: 450px)'];
      this.isMediumPhone = breakpoints['(max-width: 575px)'];

      this.showCompactButtons = breakpoints['(max-width: 450px)'];

      this.isTablet = breakpoints['(max-width: 768px)'];
      this.isMobile = breakpoints['(max-width: 991px)'];
      this.isDesktop = breakpoints['(min-width: 992px)'];
      this.isMediumDesktop = breakpoints['(max-width: 1200px)'];
      this.isPortrait = breakpoints['(orientation: portrait)'];
      this.isLandscape = breakpoints['(orientation: landscape)'];
    });
  }

}